import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { Box } from '@mui/material';

interface MarkdownViewerProps {
  content: string;
}

const MarkdownViewer: React.FC<MarkdownViewerProps> = ({ content }) => {
  return (
    <Box
      sx={{
        color: "inherit",
        "& a": {
          color: "var(--color-link)",
          textDecoration: "underline",
        },
        "& code, & pre, & strong, & em, & li, & p, & h1, & h2, & h3, & h4, & h5, & h6":
          {
            color: "inherit",
          },
      }}
    >
      <ReactMarkdown
        children={content}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
      />
    </Box>
  );
};

export default MarkdownViewer;
